import { render, staticRenderFns } from "./newsSorotan.vue?vue&type=template&id=4b1d96fa&scoped=true&"
import script from "./newsSorotan.vue?vue&type=script&lang=js&"
export * from "./newsSorotan.vue?vue&type=script&lang=js&"
import style0 from "./newsSorotan.vue?vue&type=style&index=0&lang=css&"
import style1 from "./newsSorotan.vue?vue&type=style&index=1&id=4b1d96fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1d96fa",
  null
  
)

export default component.exports